import { render, staticRenderFns } from "./schoolLogs.vue?vue&type=template&id=bfd15f64&"
import script from "./schoolLogs.vue?vue&type=script&lang=js&"
export * from "./schoolLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports